import { render } from "./UnitRecoverAssets.vue?vue&type=template&id=5f9ae44f&scoped=true"
import script from "./UnitRecoverAssets.vue?vue&type=script&lang=js"
export * from "./UnitRecoverAssets.vue?vue&type=script&lang=js"

import "./UnitRecoverAssets.vue?vue&type=style&index=0&id=5f9ae44f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9ae44f"]])

export default __exports__